import * as React from 'react';
import { connect } from 'react-redux';
import { CustomQuestionEditModal, ICustomQuestionEditModalProps } from '../../components/questions/CustomQuestionEditModal';
import { IApplicationState } from '../../store';
import { ActionCreators } from '../../store/CustomQuestionStore';

export const CustomQuestionEditModalContainer: React.ComponentType<ICustomQuestionEditModalProps> = connect(
	(state: IApplicationState) => ({ unsavedChanges: state.customQuestion.unsavedQuestionChanges }),
	{ ...ActionCreators },
)(CustomQuestionEditModal);
